import { useState } from "react";

const faqs = [
  {
    q: "动漫之家打不开怎么办？",
    a: "动漫之家偶尔会因为网络波动或访问高峰暂时无法打开。建议先刷新页面、更换浏览器或切换网络（移动数据与 WiFi 互切），再尝试从本页的网页版入口进入。若仍然无法打开，可稍后重试，官方网址更新后会第一时间同步到本页。",
  },
  {
    q: "动漫之家换网址了，如何找到新站？",
    a: "动漫之家地址更新后，请以本页「访问入口」栏公布的最新官网地址为准，避免从搜索引擎点进仿冒站点。点击「立即进入」或「进入网页版」即可直达最新可用网址，收藏本页可随时回来获取更新。",
  },
  {
    q: "网页版和 APP 有什么区别？",
    a: "网页版无需安装、浏览器即开即用，适合电脑大屏追番；APP 支持离线缓存、弹幕互动和追更提醒，适合随时随地使用。两者内容同步，账号收藏与观看进度互通，可无缝切换。",
  },
  {
    q: "换网址后我的追番记录还在吗？",
    a: "只要使用同一账号登录，动漫之家的观看进度、收藏与追更列表都会云端同步，换网址或换设备登录后即可恢复。首次登录新站建议先确认账号无误，再进行观看。",
  },
  {
    q: "如何判断是不是仿冒网站？",
    a: "请认准本页公布的官方入口与域名标识，仿冒站点通常要求异常授权或弹窗频繁。尽量通过本页直达，不要轻易在陌生页面输入账号密码，保护好个人信息与账号安全。",
  },
  {
    q: "APP 下载后无法安装怎么办？",
    a: "若 APP 安装失败，请先检查系统版本是否满足要求，并允许「安装未知来源应用」权限。部分机型需在设置中开启后重试。仍无法解决时，可在本页底部通过联系邮箱反馈具体报错信息。",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[380px_1fr]">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-question-line"></i> 常见问题
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
              追番路上，为你答疑
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于动漫之家打不开、换网址、网页版与 APP 使用、账号同步等常见问题，
              我们都整理在下方。点击问题即可展开查看详细解答。
            </p>
            <a
              href="#download"
              className="mt-6 inline-flex w-fit whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
            >
              <i className="ri-download-2-line mr-1"></i>还没下载？去下载 APP
            </a>
          </div>

          <div className="space-y-3">
            {faqs.map((item, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={item.q}
                  className={`overflow-hidden rounded-xl border transition-colors ${
                    open ? "border-primary-300 bg-primary-50/60" : "border-background-200 bg-background-100"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="text-sm font-bold text-foreground-950 md:text-base">{item.q}</h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-transform ${
                        open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-50 text-foreground-700"
                      }`}
                    >
                      <i className="ri-add-line text-lg"></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}